import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Close';
import React, { useState } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    addPermissionPanel: {
      padding: 16,
      backgroundColor: darken(theme.palette.background.default, 0.02),
      display: 'flex'
    },
    addPermissionTextField: {
      marginRight: 16
    },
    removePermissionTableCell: {
      width: 50
    },
    noPermissionsText: {
      marginTop: 24
    }
  })
);

interface Props {
  allowedArns: any;
  onAllowedArnsChange: (arns: string[]) => void;
}

function FamilyWorkflowPermissionsEditor(props: Props) {
  const { allowedArns, onAllowedArnsChange } = props;
  const [serviceArnToAdd, setServiceArnToAdd] = useState('');
  const [permissions, setPermissions] = useState(allowedArns.map(arn => ({ id: arn, name: arn })));

  const classes = useStyles({});

  const updatePermissions = (newPermissions: any[]) => {
    setPermissions(newPermissions);
    onAllowedArnsChange(newPermissions.map(permission => permission.id));
  };

  const onAddServiceArn = () => {
    // Check if arn already exists
    if (!permissions.some(permission => permission.id === serviceArnToAdd)) {
      const permissionsCopy = permissions.slice();
      permissionsCopy.push({ id: serviceArnToAdd, name: serviceArnToAdd });
      updatePermissions(permissionsCopy);
    }
    setServiceArnToAdd('');
  };

  const onRemovePermission = (permission) => () => {
    const permissionsCopy = permissions.slice();
    permissionsCopy.splice(permissionsCopy.indexOf(permission), 1);
    updatePermissions(permissionsCopy);
  };

  const onServiceArnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setServiceArnToAdd(event.target.value);
  };

  return (
    <div>
      <div className={classes.addPermissionPanel}>
        <TextField
          className={classes.addPermissionTextField}
          label='Service ARN'
          value={serviceArnToAdd}
          onChange={onServiceArnChange}
          fullWidth
          placeholder="ARN of IAM user, role, instance profile, or lambda function"
          InputLabelProps={{
            shrink: true
          }} />
        <Button
          disabled={!serviceArnToAdd}
          color={!serviceArnToAdd ? 'default' : 'primary'}
          variant='outlined'
          onClick={onAddServiceArn}
        >
          Add
        </Button>
      </div>
      <TableContainer>
        <Table>
          <TableBody>

            {permissions.map(permission => <TableRow key={permission.id}>
              <TableCell>
                <Typography>{permission.name}</Typography>
              </TableCell>
              <TableCell align='right' className={classes.removePermissionTableCell}>
                <IconButton onClick={onRemovePermission(permission)}><DeleteIcon /></IconButton>
              </TableCell>
            </TableRow>)}
          </TableBody>
        </Table>
      </TableContainer>
      {permissions.length === 0 && <Typography variant="caption" display="block" className={classes.noPermissionsText}>
        To add a new permission, enter an ARN above and select "Add"
      </Typography>}
    </div>);
};

export default FamilyWorkflowPermissionsEditor;
